import React from "react"

import InlineLinkListItem from "@atoms/InlineLinkListItem/InlineLinkListItem"
import Paragraphs from "@atoms/Paragraphs/Paragraphs"

import styles from "./CardPlain.module.scss"

const CardPlain = ({ heading, text, list, headingSize, link }) => {
  const Heading = headingSize

  let items = []

  if (list) {
    list.forEach((item, i) => {
      items.push(<li key={i}>{item}</li>)
    })
  }

  // {list && <ul>{items}</ul>}

  return (
    <div className={styles.item}>
      <Heading>{heading}</Heading>
      <div>
        <Paragraphs content={text} />
      </div>
      {link && (
        <div className={styles.link}>
          <InlineLinkListItem
            href={link.url}
            text={link.title}
            internal={link.target !== "_blank"}
            element="p"
          />
        </div>
      )}
    </div>
  )
}

CardPlain.defaultProps = {
  headingSize: "h3",
}

export default CardPlain
